import { IconProps } from "@/common/contracts/icon.contracts";

export const FavoriteOn = (props: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.7983 27.2741C16.7853 28.2125 15.2259 28.2125 14.213 27.2605L14.0664 27.1245C7.06908 20.6644 2.49751 16.4348 2.67078 11.1579C2.75074 8.84593 3.9103 6.62911 5.78958 5.3235C9.30822 2.87548 13.6532 4.01789 15.999 6.81951C18.3447 4.01789 22.6897 2.86188 26.2084 5.3235C28.0877 6.62911 29.2472 8.84593 29.3272 11.1579C29.5138 16.4348 24.9289 20.6644 17.9316 27.1517L17.7983 27.2741Z"
        fill="#FE49AD"
      />
    </svg>
  );
};
